import type { BridgeTypes } from './types';

declare global {
  interface Window {
    Bridge: BridgeTypes;
  }
}

const noopBridge: BridgeTypes = {
  setMasterToken: () => {},
  setSessionToken: () => {},
  getMasterToken: () => '',
  getSessionToken: () => '',
  showHomePage: () => {},
  updateBasket: () => {},
  updateWishlist: () => {},
  showMyAccount: () => {},
  orderConfirmation: () => {},
  setBonuscodes: () => {},
  getBonuscodes: () => '',
  setLoyaltyCodes: () => {},
  getLoyaltyCodes: () => '',
  setLoyaltycodes: () => {},
  getLoyaltycodes: () => '',
  setTitle: () => {},
  setSubTitle: () => {},
  showDetailView: () => {},
  downloadDocument: () => {},
  openUrl: () => {},
};

/**
 * The native app's bridge, or a stand-in whose methods do nothing outside the app. Looked up on
 * every call, because the app may inject `window.Bridge` after this module was imported.
 */
export const getBridge = (): BridgeTypes =>
  typeof window !== 'undefined' && typeof window.Bridge !== 'undefined'
    ? window.Bridge
    : noopBridge;
